<template>
  <div class="home-about">
    <div class="container">
      <div class="habout-inner">
        <div class="stars text-center">
          <img src="../assets/images/star-icon.png" alt />
          <img src="../assets/images/star-icon.png" alt />
          <img src="../assets/images/star-icon.png" alt />
          <img src="../assets/images/star-icon.png" alt />
        </div>
        <h2 class="relative-section text-center section-title font-balo font-bold">
          <span>{{landingPage.hex_subtitle}}</span>
          <b>{{landingPage.hex_title}}</b>
        </h2>
        <div class="des" v-html="landingPage.hex_des"></div>
        <div class="text-center">
          <a
            :href="landingPage.hex_link"
            class="btn font-balo font-bold"
          >{{$t('app.en savoir plus')}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "LandingAbout",
  computed: {
    ...mapState({
      landingPage: state => get(state, "app.landingPage")
    })
  }
};
</script>
